module.exports = __webpack_public_path__ + "img/riskItem_bg.9f629301.png";